// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    margin: 0;
    padding: 0;
    width: 100vw;
    height: 100vh;
    background-color: #eceff1;
}

#root {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}
  
.MuiDataGrid-columnHeaders {
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["html, body {\n    margin: 0;\n    padding: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: #eceff1;\n}\n\n#root {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n}\n  \n.MuiDataGrid-columnHeaders {\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
